import { findGameBySlug } from "@/data/games";
import { GameDetailPage } from "@/pages/GameDetailPage";
import { AppProviders } from "@/app/providers";
import { LandingPage } from "@/pages/LandingPage";
import { LegalPage } from "@/pages/LegalPage";
import { SupportPage } from "@/pages/SupportPage";

const legalRoutes = new Set(["/privacy", "/terms"]);

export function App() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const gameMatch = /^\/games\/([^/]+)$/.exec(path);
  const legacyGameMatch = /^\/([^/]+)$/.exec(path);
  const nestedLegalMatch = /^\/([^/]+)\/(privacy|terms|support)$/.exec(path);
  const game =
    gameMatch
      ? findGameBySlug(gameMatch[1])
      : legacyGameMatch
        ? findGameBySlug(legacyGameMatch[1])
        : undefined;
  const nestedGame = nestedLegalMatch
    ? findGameBySlug(nestedLegalMatch[1])
    : undefined;
  const nestedKind = nestedLegalMatch?.[2];

  return (
    <AppProviders>
      {nestedGame && nestedKind === "support" ? (
        <SupportPage />
      ) : nestedGame && (nestedKind === "privacy" || nestedKind === "terms") ? (
        <LegalPage kind={nestedKind} />
      ) : game ? (
        <GameDetailPage game={game} />
      ) : legalRoutes.has(path) ? (
        <LegalPage kind={path === "/terms" ? "terms" : "privacy"} />
      ) : path === "/support" ? (
        <SupportPage />
      ) : (
        <LandingPage />
      )}
    </AppProviders>
  );
}
